export default __webpack_public_path__ + "static/beneficios-1-eec37faa81f0f01355d29bed69e4106f.jpg";